import { z } from 'zod';

export const CoreEnvironmentTypeSchema = z.enum(['Live','Inactive','Demo','Qa','Internal','Test']);

export type CoreEnvironmentTypeType = `${z.infer<typeof CoreEnvironmentTypeSchema>}`

export default CoreEnvironmentTypeSchema;
